import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const BusinessPartnerPaymentDetails = ({ data }) => {
  return (
    <DescriptionList stripEmpty={true} data={data} disableGutters={true}>
      <DescriptionItem label={'Bank name'} field={'paymentDetails.bankName'} />
      <DescriptionItem
        label={'Bank address'}
        field={'paymentDetails.bankAddress'}
      />
      <DescriptionItem
        label={'Account number'}
        field={'paymentDetails.accountNumber'}
      />
      <DescriptionItem label={'Account'} field={'paymentDetails.accountName'} />
      <DescriptionItem
        label={'Swift code'}
        field={'paymentDetails.swiftCode'}
      />
      <DescriptionItem label={'IBAN'} field={'paymentDetails.iban'} />
    </DescriptionList>
  );
};

export default BusinessPartnerPaymentDetails;
